/* eslint-disable */
// @ts-nocheck
import type { ExportInfo } from '../../types/customExportTypes';
import { convertToTimezone, createMomentObjInTimezone, getLabelForTimezoneName } from '../../support/dateUtils';
export const processExportInfo = (exports: Array<ExportInfo>) =>
  exports.map((exportInfo) => {
    let { dateCreated, startDate, endDate, timezone } = exportInfo;
    // dateCreated is returned from Waldo in UTC - convert it to app timezone
    const UTCDateCreated = createMomentObjInTimezone(dateCreated, 'Etc/UTC').format();
    dateCreated = convertToTimezone(UTCDateCreated);
    // start and end date are returned in whatever timezone the user specified for that export
    // we wish to preserve this timezone (NOT convert it to the app timezone)
    // convert start and end date to proper format for createMomentObjInTimezone
    startDate = decodeURIComponent(startDate).split('T').join(' ') + '.000';
    endDate = decodeURIComponent(endDate).split('T').join(' ') + '.000';
    startDate = createMomentObjInTimezone(startDate).format();
    endDate = createMomentObjInTimezone(endDate).format();
    // we wish to render the timezone label, not the name in the UI
    // i.e. (GMT-07:00) America/Los Angeles instead of America/Los_Angeles
    timezone = getLabelForTimezoneName(timezone);
    return { ...exportInfo, dateCreated, startDate, endDate, timezone };
  });
